import { useState, useEffect } from "react";
import useHttpUtility from "../utilities/useHttpUtility";
import LoadingScreen from "../components/LoadingScreen";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemOk from "../components/MenuPageItemOk";
import Table from "../components/Table";

export default function ScheduleSelectionSection({ onOk, onDiscard }) {
    
    const httpUtility = useHttpUtility();
    const [data, setData] = useState(null);
    const [region, setRegion] = useState(null);
    const [scheduleIndex, setScheduleIndex] = useState(-1);

    useEffect(() => {
        httpUtility.get("/api/Schedules", (d) => {
            setData(d);
            setRegion(d.length > 0 ? d[0] : null)
        });
    }, []);

    return (
        !data
            ? <LoadingScreen isFullScreen={false} />
            :
            <div className="schedule-selection-section">
                <MenuPage>
                    <MenuPageItemDiscard onClick={onDiscard} />
                    {
                        scheduleIndex >= 0
                            ? <MenuPageItemOk onClick={() => onOk(region.schedules[scheduleIndex])} />
                            : null
                    }
                </MenuPage>
                <div>
                    <p>Highlight a schedule from the list below and then click the OK button on the top right.</p>
                    <p>If there are no services shown or you need to enable some services not in the list, visit <a href="https://urgent.co.nz" target="_blank"><b>https://urgent.co.nz</b></a> and hit the live chat button to speak with a member of the sales team.</p>
                    <div class="regions-tab">
                        {
                            data.map(d =>
                                <div
                                    className={`region-tab${region?.region === d.region ? " active" : ""}`}
                                    onClick={() => {
                                        if (region?.region === d.region)
                                            return;

                                        setScheduleIndex(-1);
                                        setRegion(d);
                                    }}>
                                    {d.region?.toUpperCase()}
                                </div>)
                        }
                    </div>
                    <Table
                        mappings={[
                            {
                                header: "Name",
                                field: "name"
                            },
                            {
                                header: "Service",
                                field: "speed"
                            },
                            {
                                header: "Day",
                                field: "dayOfWeek",
                                dataType: "dayOfWeek"
                            },
                            {
                                header: "Start Time",
                                field: "startTime",
                                dataType: "time"
                            },
                            {
                                header: "End Time",
                                field: "endTime",
                                dataType: "time"
                            },
                            {
                                header: "Preparation",
                                field: "preparation"
                            }
                        ]}
                        data={region?.schedules}
                        selectedIndex={scheduleIndex}
                        pageSize={15}
                        onClick={setScheduleIndex}
                        onDoubleClick={(idx) => {
                            setScheduleIndex(idx);
                            onOk(region.schedules[idx])
                        }}
                    />
                </div>
            </div>
    );
}